import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-it/htdocs/it.athakai.com/app/components/AnimatedMouse.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-it/htdocs/it.athakai.com/app/components/CountWrapper.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-it/htdocs/it.athakai.com/app/components/FormDetails.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-it/htdocs/it.athakai.com/app/components/GroupData.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-it/htdocs/it.athakai.com/app/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-it/htdocs/it.athakai.com/app/components/Posts.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-it/htdocs/it.athakai.com/app/components/PromoShow.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-it/htdocs/it.athakai.com/app/components/ShopData.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-it/htdocs/it.athakai.com/app/components/SlideCard.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/athakai-it/htdocs/it.athakai.com/app/components/TypingText.js");
;
import(/* webpackMode: "eager" */ "/home/athakai-it/htdocs/it.athakai.com/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/athakai-it/htdocs/it.athakai.com/node_modules/next/dist/client/image-component.js");
